import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils';

const Home = ({ fill, ...props }) => (
	<svg width={15} height={13} viewBox="0 0 15 13" {...props}>
		<path 
			fill={fill}
			d="M7.5 1.7L1.3 6.8a.5.5 0 11-.6-.7L7.2.6h.6l6.5 5.5a.5.5 0 01-.6.7L7.5 1.7zm-.8 8.1v2.7c0 .2-.3.5-.5.5H3a.5.5 0 01-.5-.5V7a.5.5 0 011 0v5h2.2V9.3c0-.2.2-.5.5-.5h2.4c.2 0 .5.3.5.5V12h2.1V7a.5.5 0 011 0v5.5c0 .2-.2.5-.5.5H8.6a.5.5 0 01-.5-.5V9.8H6.7z"
		/>
	</svg>
);

Home.propTypes = {
	fill: PropTypes.string
};

Home.defaultProps = {
	fill: getColor('mutedGray'),
};

export default Home;
